import { RestClient } from "./restClient";

export class ReplayService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	// Save a replay
	saveReplay(replay, callback) {
		const url = "/ecosystem/api/replay/saveReplay";
		const body = JSON.stringify({
			replay
		});
		this._restClient.exec_post(url, body, callback);
	}

	getAllReplays(callback) {
		const url = "/ecosystem/api/replay";
		this._restClient.exec_get(url, callback);
	}

	updateReplay(replayId, replay, callback) {
		const url = `/ecosystem/api/replay/updateReplay/${replayId}`;
		const body = JSON.stringify({
			replay
		});
		this._restClient.exec_put(url, body, callback);
	}

	deleteReplays(replayIds, callback) {
		const url = "/ecosystem/api/replay/deleteReplays";
		const body = JSON.stringify({
			replayIds
		});
		this._restClient.exec_put(url, body, callback);
	}

	// cSpell:ignore bbox
	/**
	 * getSnapshot
	 * retrieve an array of active entities at given time
	 * @param at ISO timestamp UTC time for which snapshot entities are returned
	 * @param filter a filter, mostly geo, that can be defined to further limit entities in snapshot
	 *               currently only supports a bounding box in format
	 *                   {
	 *                       "type": "bbox",
	 *                       "coordinates": [
	 *                           [-118.45184326171875, 33.80996124558631],
	 *                           [-117.96707153320314, 33.509911888077184]
	 *                       ]
	 *                   }
	 *               where coordinates are upper left, lower right bounds of bbox
	 * @param callback
	 */
	getSnapshot(from, to, filter, callback) {
		const url = "/ecosystem/api/replay/getSnapshot";
		const body = JSON.stringify({
			from: from,
			to: to,
			filter: filter
		});
		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	/**
	 * getTransactions
	 * retrieve an array of all entity transactions in given time span
	 * this uses scroll api to page results
	 * pageSize in the maximum number of results per page, the last page will almost always have less then pageSize
	 * On first request scrollId will not be required. The response return the scrollId (for use in subsequent requests) and the total number of transaction to expect
	 * for example:
	 * {
	 *       "scrollId": "DnF1ZXJ5VGhlbkZldGNoBgAAAAAAASHyFkhfOGJiaWNWUklXUHVkelV4UERmVXcAAAAAAAEh8xZIXzhiYmljVlJJV1B1ZHpVeFBEZlV3AAAAAAABIfUWSF84YmJpY1ZSSVdQdWR6VXhQRGZVdwAAAAAAASH0FkhfOGJiaWNWUklXUHVkelV4UERmVXcAAAAAAAEh9hZIXzhiYmljVlJJV1B1ZHpVeFBEZlV3AAAAAAABIfcWSF84YmJpY1ZSSVdQdWR6VXhQRGZVdw==",
	 *       "total": 396,
	 *       "count": 10,
	 *       "items": [...]
	 *   }
	 * each request with scrollId automatically return the next pageSize results. You can keep requesting until count === 0 at which point you should have all transactions
	 * note the page size stays same as initial request so you can't change page size on subsequent requests when using scrollId
	 * each entity returned will include  "transactionTime" ISO UTC Date which can be used by the client for updating client state appropriately with slider movement
	 *
	 * @param from ISO timestamp UTC time start of range in which to retrieve transactions
	 * @param to ISO timestamp UTC time end of range in which to retrieve transactions
	 * @param filter a filter, mostly geo, that can be defined to further limit entities in snapshot
	 *               currently only supports a bounding box in format
	 *                   {
	 *                       "type": "bbox",
	 *                       "coordinates": [
	 *                           [-118.45184326171875, 33.80996124558631],
	 *                           [-117.96707153320314, 33.509911888077184]
	 *                       ]
	 *                   }
	 *               where coordinates are upper left, lower right bounds of bbox
	 * @param pageSize max number of transactions returned per request
	 * @param scrollId null on initial request. returned in initial request and included on subsequent requests to retrieve additional pages of results
	 * @param callback
	 */
	getTransactions(to, from, filter, pageSize = 1000, scrollId = null, callback) {
		const url = "/ecosystem/api/replay/getTransactions";
		const body = JSON.stringify({
			from: from,
			to: to,
			filter: filter,
			pageSize: pageSize,
			scrollId: scrollId
		});
		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getTimelineAlerts(to, from, filter, callback) {
		const url = "/ecosystem/api/replay/getTimelineAlerts";
		const body = JSON.stringify({
			from: from,
			to: to,
			filter: filter
		});
		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getAlertTransactions(to, from, filter, callback) {
		const url = "/ecosystem/api/replay/getAlertTransactions";
		const body = JSON.stringify({
			from: from,
			to: to,
			filter: filter
		});
		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}
}
